import { render } from "./SitiosRecomendadosSection.vue?vue&type=template&id=51feb7c9&scoped=true"
import script from "./SitiosRecomendadosSection.vue?vue&type=script&lang=js"
export * from "./SitiosRecomendadosSection.vue?vue&type=script&lang=js"

import "./SitiosRecomendadosSection.vue?vue&type=style&index=0&id=51feb7c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51feb7c9"]])

export default __exports__